import localhost from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";
import { clearJobQueue } from "slices/app/appSlice";
import { setLicenseInfo } from "slices/userAdmin/userAdminSlice";

export const fetchLicenseInfo = () => async (dispatch) => {
  await localhost
    .get("/docs/userAdmin/license")
    .then(async (response) => {
      const { data } = response;
      dispatch(setLicenseInfo(data));
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};
